import axios from 'axios';

// Determine API base URL based on environment
const getApiBaseUrl = () => {
  // Always use environment variable if available
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Fallback for development
  return 'http://localhost:5000/api';
};

// Create axios instance
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Generate smart game list
export const generateSmartList = async (criteria) => {
  try {
    const response = await api.post('/smart-lists/generate', criteria);
    return response.data.success ? response.data.data : null;
  } catch (error) {
    console.error('Error generating smart list:', error);
    return null;
  }
};

// Get user statistics
export const getUserStats = async (userId) => {
  try {
    const response = await api.get(`/smart-lists/user-stats/${userId}`);
    return response.data.success ? response.data.data : null;
  } catch (error) {
    console.error('Error fetching user stats:', error);
    return null;
  }
};
